/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { ticketColors } from '../../shared/theme/public-api';

type Props = {
  children: React.ReactNode;
  /**
   * When set, centers a capped column inside a full-bleed panel.
   * Use for settings/shell forms — not for operational tabs (use useTabWorkspaceLayout, no cap).
   */
  maxWidth?: number;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

/**
 * Shell tab / panel wrapper: always paints the full panel with app background.
 * Do not put alignSelf:center on the outer flex:1 screen root — it leaks the white
 * html body on web in the margins (POS PC, etc.).
 */
export function ShellContentFrame({ children, maxWidth, style, testID }: Props) {
  const cap = maxWidth != null;

  return (
    <View style={[styles.outer, style]} testID={testID}>
      {cap ? <View style={[styles.inner, { maxWidth }]}>{children}</View> : children}
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    flex: 1,
    width: '100%',
    alignSelf: 'stretch',
    backgroundColor: ticketColors.bg,
  },
  inner: {
    flex: 1,
    width: '100%',
    alignSelf: 'center',
  },
});
